module.exports = __webpack_public_path__ + "static/media/departure-work.67bc38fe.png";